// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@awc/XDL/Utilities";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface SharedCustomFormsStyles {
    formWrapper?: InjectableCss;
    inputsWrapper?: InjectableCss;
    submitButton?: ButtonPresentationProps;
    fileUpload?: InjectableCss;
}

export const sharedCustomFormsStyles: SharedCustomFormsStyles = {
    formWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
        `,
    },

    inputsWrapper: {
        css: css`
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px 16px;
            ${xScreen("lte", "sm")} {
                grid-template-columns: 1fr;
            }
        `,
    },

    fileUpload: {
        css: css`
            > div {
                display: flex;
                align-items: flex-end;
                gap: 16px;
                .mobiusFileUpload {
                    padding: 0 8px !important;
                }
                .mobiusFileVisual {
                    max-width: calc(100% - 60px) !important;
                    padding-right: 0 !important;
                }
            }
            ${xScreen("lte", "sm")} {
                > div {
                    flex-direction: row;
                    [class^="ButtonWrapper"] {
                        width: auto;
                    }
                }
            }
        `,
    },

    submitButton: {
        variant: "tertiary",
        css: css`
            width: fit-content;
            margin-top: 20px;
        `,
    },
};
